import { render, staticRenderFns } from "./BotPerformanceWidget.vue?vue&type=template&id=66008828&scoped=true&"
import script from "./BotPerformanceWidget.vue?vue&type=script&lang=js&"
export * from "./BotPerformanceWidget.vue?vue&type=script&lang=js&"
import style0 from "./BotPerformanceWidget.vue?vue&type=style&index=0&id=66008828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66008828",
  null
  
)

export default component.exports